// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2i0yQ","header":"ReportDetails_header__2BiEf","title":"ReportDetails_title__448OB","left":"ReportDetails_left__3GvEs"};